import { SimpleStudentT } from 'types/shared/core/Student';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material';
import StudentHelper from 'utils/StudentHelper';
import PersonItem from './PersonItem';

// 뭔가 학생들의 리스트를 화면 중앙에 보여준다.

type StudentsDialogPropsT = {
  title: string;
  students: SimpleStudentT[];
  open: boolean;
  onClose: () => void;
};

export default function StudentsDialog({
  title,
  students,
  open,
  onClose,
}: StudentsDialogPropsT) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">{title}</DialogTitle>
      <DialogContent dividers>
        {students.length === 0 ? (
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{ minWidth: 228 }}
          >
            선택된 학생이 없습니다.
          </Typography>
        ) : (
          <Grid container spacing={2} sx={{ minWidth: 228 }}>
            {students.map((student) => (
              <PersonItem
                variant="grid"
                key={student.id}
                avatarSrc={student.profileUrl}
                name={student.name}
                descText={StudentHelper.studentDesc(student)}
                extraText=""
                onClick={() => {
                  console.log('onClick');
                }}
              />
            ))}
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>닫기</Button>
      </DialogActions>
    </Dialog>
  );
}
